module.exports = __webpack_public_path__ + "img/DAVID_CANNON_32-rs.3b30bc71.jpg";